import { ChangeDetectionStrategy, Component, HostBinding, Input, ViewEncapsulation } from "@angular/core";
import { BlogPost } from "@obg/ngx.common";

@Component({
	selector: "obg-post",
	templateUrl: "./post.component.html",
	styleUrls: ["./post.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class PostComponent {
	@HostBinding("class.obg-post") hostCssClass = true;
	@Input() post: BlogPost | undefined;
}
